import { EventPanelData } from './state/entity-panel-manager';
import { useWatch } from 'react-hook-form';
import React from 'react';
import { EventItem } from './event-item';

export function ExistingEventItem(props: { eventPanel: EventPanelData }) {
    const { eventPanel } = props;
    const selectedCfs = useWatch({
        control: props.eventPanel?.form.control,
        name: 'callForService',
        disabled: !props.eventPanel?.form.control,
    })?.label;
    const cfsText =
        [eventPanel.metadata?.callForServiceCode, eventPanel.metadata?.callForServiceDescription]
            .filter((x) => !!x)
            .join(' - ') || selectedCfs;
    return (
        <EventItem
            eventPanel={eventPanel}
            agencyEventNumber={eventPanel.metadata?.agencyEventNumber}
            cfsText={cfsText}
            eventId={eventPanel.metadata?.eventId}
            agencyTypeGlobalAttrId={eventPanel.metadata?.agencyTypeGlobalAttrId}
            isHistorical={false}
            key={eventPanel.workspacePanel.uuid}
        />
    );
}
